<div class="p-grid">
    <div class="p-col-12">
        <app-filter [filterByInput]="cols" [filterByInputValue]="filterByInputValue" [selectedFilterGroup]="selectedFilterGroup"
            (onRemoveFilter)="onRemoveFilter(selectedWindow, $event)" (onClosePanel)="onClosePanel(selectedWindow)"
            (onApplyFilter)="onApplyFilter(selectedWindow, $event)" (onModifyFilterOptions)="onModifyFilterOptions(selectedWindow, $event)"
            (onChangeRange)="onChangeRange(selectedWindow, $event)" [showChannelFilter]="true" [showModuleFilter]="true"
            (onChangeChannel)="onChangeChannel(selectedWindow, $event)" [channelList]="channelList" [selectedChannel]="selectedChannel"
            (onChangeModule)="onChangeModule(selectedWindow, $event)"  [moduleList]="moduleList"  [selectedModule]="selectedModule" >
        </app-filter>
    </div>

    <div class="p-col-12">
        <div class="card">
            <div class="main-content">
                <div id="divLeadsReport">
                    <div class="p-d-flex p-jc-between">
                        <h5>{{reportName}}</h5>
                        <h4>{{organizationName}}</h4>
                        <h5>
                            {{ currentDateTime | localDate: 'MM/DD/YYYY | h:mm a'}}
                        </h5>
                    </div>

                    <app-table [reportType]="'simpleTBWithAPIPagination'" [reportDatas]="reportsData"
                        [cols]="cols" [totalRecords]="reportsTotalRecord" [showTitle]="false"
                        (onClickPaginationData)="getPaginationData($event)"
                        (onPopupLinkClick)="onPopupLinkClick($event)">
                    </app-table>
                </div>
            </div>
        </div>
    </div>

</div>


<!-- Account View/Edit Component -->
<app-edit-account
    *ngIf="displayAccountViewEdit"
    [displayEditViewDialog]="displayAccountViewEdit"
    [displayView]="true"
    [selectedAccountId]="selectedAccountId"
    [selectedChannelId]="selectedChannelId"
    (getAccountListAfterEdit)="getAccountListAfterEdit()"
    (closeModal)="closeAccountViewEditModal()">
</app-edit-account>

<!-- Lead View/Edit -->
<app-add-update-view-lead
    *ngIf="displayLeadViewEdit"
    [display]="displayLeadViewEdit"
    [selectedLeadId]="selectedLeadId"
    [selectedChannelId]="selectedChannelId"
    [crudType]="'view'"
    (cancelClicked)="closeLeadViewEdit()"
    (onComplete)="reloadResultAfterSave()">
</app-add-update-view-lead>
